import React, { useEffect, useState, useImperativeHandle, forwardRef } from "react"
import { Tabs, Card, Form, Row, Col, Select, DatePicker, Collapse, TimePicker, Modal, Popconfirm } from 'antd';
import Input from '../../../ui/Input';
import TextArea from '../../../ui/TextArea';
import { PlusOutlined } from '@ant-design/icons'
import { getOTACodes } from '../../../../services/common'
import { CloseCircleOutlined } from '@ant-design/icons';
const { TabPane } = Tabs;
const { Option } = Select;

let newTabIndex = 10;
let newTabIndexArr: any = [];
let errHandle = false;
const AddAccessibilityAndSecurity = forwardRef((props: any, ref: any) => {
  const [form]: any = Form.useForm()
  const { Panel } = Collapse;
  const dateFormat = 'MM/DD/YYYY';
  const itemFormat = 'HH:mm';
  const FormItem = Form.Item
  const [refreshCount, setRefreshCount] = useState(1)
  const [currencyList, setCurrencyList] = useState<Array<any>>([]);
  const [chargeUnitList, setChargeUnitList] = useState<Array<any>>([]);
  const [ChargeFrequency, setChargeFrequency] = useState<Array<any>>([]);

  const [requiredFlag, setRequiredFlag] = useState(true)
  const [addId, setAddId] = useState(0);
  const initData = [
    {
      closable: false,
      'id': addId,
      "startdate": "",
      "enddate": "",
      "description": "",
      "operationtime": [
        {
          "dayoftheweek": "Mon",
          "starttime": '',
          "endtime": ''
        },
        {
          "dayoftheweek": "   Tue",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Wed",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Thu",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Fri",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Sat",
          "starttime": "",
          "endtime": ""
        }, {
          "dayoftheweek": "Sun",
          "starttime": "",
          "endtime": ""
        }
      ],
      "charge": [
        {
          "type": "",
          "charge": "",
          "currency": "",
          "chargeunit": "",
          "chargefrequency": ""
        }
      ]
    }
  ]
  const data = initData
  const detailData = data
  useEffect(() => {
    newTabIndex = panes.length > 0 ? Number(panes.length) : 0;
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])
  const onChangeItem = () => {
    setRequiredFlag(true)
  }
  const getCurrencyist = async () => {
    // setAddLoading(true)
    let res = await getOTACodes('CUR', '')
    // setAddLoading(false)
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setCurrencyList(res.otacodes)
    } else {
      setCurrencyList([])
    }
  }
  const getChargeUnitList = async () => {
    // setAddLoading(true)
    let res = await getOTACodes('CHG ', 'ChargeUnit')
    // setAddLoading(false)
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setChargeUnitList(res.otacodes)
    } else {
      setChargeUnitList([])
    }
  }
  const getChargeFrequencyList = async () => {
    // setAddLoading(true)
    let res = await getOTACodes('CHG ', 'ChargeFrequency')
    // setAddLoading(false)
    if (res && res.otacodes && res.otacodes.length != 0) {
      res.otacodes.map((item: any) => item.key = item.codeName)
      setChargeFrequency(res.otacodes)
    } else {
      setChargeFrequency([])
    }
  }
  useEffect(() => {
    getCurrencyist()
    getChargeUnitList()
    getChargeFrequencyList()
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])
  

  const initialPanes: any = initData ? initData : []
  // props.currentLine.capacity?props.currentLine.capacity: []

  const [activeKey, setActiveKey] = useState("0")
  const [panes, setPanels] = useState(initialPanes)

  const onChange = (activeKey: any) => {
    setActiveKey(activeKey)
  };

  const onEdit = (targetKey: any, action: any) => {
    if (action == 'add') {
      add()
    } else if (action == 'remove') {
      remove(targetKey)
    }
  };

  const add = async () => {
    newTabIndex = panes.length > 0 ? Number(panes.length) : 0;
    const newKey = ++newTabIndex;
    newTabIndexArr.push(newKey)
    const newPanes = [...panes];
    let id = addId
    id++
    let obj = {
      'id': id,
      "startdate": "",
      "enddate": "",
      "operationtime": [
        {
          "dayoftheweek": "Mon",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Tue",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Wed",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Thu",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Fri",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Sat",
          "starttime": "",
          "endtime": ""
        }, {
          "dayoftheweek": "Sun",
          "starttime": "",
          "endtime": ""
        }
      ],
      "charge": [
        {
          "type": "",
          "charge": "",
          "currency": "",
          "chargeunit": "",
          "chargefrequency": ""
        },
      ],
      closable: true
    }
    setAddId(id)
    newPanes[0].closable = true;
    newPanes.push(obj);
    setActiveKey(newPanes.length - 1 + '');
    setPanels(newPanes);
    setRequiredFlag(true)
  };
  const ModalHead = () => {
    return (
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '50px',
        lineHeight: '50px',
        textIndent: '10px',
        borderBottom: '1px solid #ccc',
        color: '#fff',
        background: '#06789D',
        fontSize: 18,
        width: '100%'
      }}>Confirm</div>
    )
  }
  const remove = (targetKey: any) => {
    // let deleteTabName = panes.filter((item: any, i: any) => Number(targetKey) == i)
    let daleteTitle = ""
    panes.forEach((pane: any, i: any) => {
      if (i == targetKey) {
        daleteTitle = pane.id;
      }
    });
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      transitionName: "",
      maskTransitionName: "",
      content: `Are you sure you want to delete Schedule ${daleteTitle + 1} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk() {
        let newActiveKey = targetKey;
        let lastIndex: any;
        panes.forEach((pane: any, i: any) => {
          if (i == targetKey) {
            lastIndex = i - 1;
          }
        });
        const newPanes = panes.filter((pane: any, i: any) => i !== Number(targetKey));
        if (newPanes.length && targetKey) {
          if (lastIndex >= 0) {
            newActiveKey = JSON.stringify(newPanes.length - 1);
            newTabIndex--
          } else {
            newActiveKey = "0";
          }
        }

        if (newPanes.length === 0) {
          const newDetails = [{
            //"scheduleid": JSON.stringify(newKey),
            "startdate": "",
            "enddate": "",
            'id': 0,
            'startDatePicker': [],
            "operationtime": [
              {
                "dayoftheweek": "Mon",
                "starttime": "",
                "endtime": ""
              },
              {
                "dayoftheweek": "Tue",
                "starttime": "",
                "endtime": ""
              },
              {
                "dayoftheweek": "Wed",
                "starttime": "",
                "endtime": ""
              },
              {
                "dayoftheweek": "Thu",
                "starttime": "",
                "endtime": ""
              },
              {
                "dayoftheweek": "Fri",
                "starttime": "",
                "endtime": ""
              },
              {
                "dayoftheweek": "Sat",
                "starttime": "",
                "endtime": ""
              }, {
                "dayoftheweek": "Sun",
                "starttime": "",
                "endtime": ""
              }
            ],
            "charge": [
              {
                "type": "",
                "charge": "",
                "currency": "",
                "chargeunit": "",
                "chargefrequency": ""
              },
            ],
            closable: true
          }]
          setPanels(newDetails)
          setActiveKey(newActiveKey)
          form.resetFields()
          setRequiredFlag(false)
          return;
        }
        setPanels(newPanes)
        setActiveKey(newActiveKey)
        if (newPanes.length === 1) {
          newPanes[0].closable = false;
          setActiveKey('0')
        }
      },
      onCancel() {

      },
    });
  };
  let newValue = [{}]
  const deleteItem = (index: number, e: any) => {
    let _index
    const validData = detailData.filter((item: any, i: number) => { _index = i; return item.name || item.desc })
    if (validData.length === 1) {
      props.currentForm.setFieldsValue({
        [`type-${_index}`]: '',
        [`charge-${_index}`]: '',
        [`currency-${_index}`]: '',
        [`chargeunit-${_index}`]: '',
        [`chargefrequency-${_index}`]: ''
      })
    } else {
      const _detailData = JSON.parse(JSON.stringify(panes))
      for (let i = 0; i < _detailData.length; i++) {
        if (i === Number(activeKey)) {
          for (let j = 0; j < _detailData[i].charge.length; j++) {
            if (j == index) {

              _detailData[i].charge[j].type = null
              newValue = _detailData[i].charge.filter((item: any, val: any) => {
                return item.type != null
              })
              console.log(newValue)
              if (newValue.length === 0) {
                let lastData = _detailData[i].charge.concat([{
                  "type": "",
                  "charge": "",
                  "currency": "",
                  "chargeunit": "",
                  "chargefrequency": ""
                }])
                //form.resetFields()
                setRequiredFlag(false)
                _detailData[i].charge = lastData;

                //form.setFieldsValue(_detailData)
                setPanels(_detailData)
                setRequiredFlag(false)
                return
              }
            }

          }

        }
      }
      setPanels(_detailData)
      // const _detailData = JSON.parse(JSON.stringify(panes))
      // for (let i = 0; i < _detailData.length; i++) {
      //   if (JSON.stringify(i) === activeKey) {
      //     // _detailData[i].charge.splice(index, 1)
      //     _detailData[i].charge[index].type = "  "
      //   }
      // }
      // setPanels(_detailData)
    }
  }
  const addCertification = () => {

    let addCertificationData = JSON.parse(JSON.stringify(panes))
    for (let i = 0; i < addCertificationData.length; i++) {
      if (JSON.stringify(i) == activeKey) {
        addCertificationData[i].charge.push({
          "type": "",
          "charge": "",
          "currency": "",
          "chargeunit": "",
          "chargefrequency": ""
        })
      }
      setPanels(addCertificationData)
    }
    setRefreshCount(refreshCount + 1)

    setRequiredFlag(true)

  }

  useImperativeHandle(ref, () => ({
    form: form,
    restoreErr: () => { errHandle = false }
  }));

  useEffect(() => {
    form.resetFields()
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  useEffect(() => {
    if (errHandle) {
      props.validateFieldsError();
    } else {
      errHandle = true;
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [panes])

  return (
    <>
      <div style={{ background: '#fff', marginBottom: '100px' }}>
        <Form
          layout="vertical"
          form={form}
          name="basic"
          initialValues={panes}
          onValuesChange={() => {
            props.validateFieldsError();
          }}

        >
          <Tabs
            type="editable-card"
            onChange={onChange}
            activeKey={activeKey}
            onEdit={onEdit}
          >
            {panes.map((schedule: any, index: number) => (
              <TabPane tab={'Schedule ' + (schedule.id + 1)} key={index}>
                <Card>
                  <Row gutter={24}>
                    <Col span={12}>
                      <FormItem name={[schedule.id, 'startDatePicker']} label="Start Date ~ End Date">
                        <DatePicker.RangePicker onChange={onChangeItem} format={dateFormat} />
                      </FormItem>
                    </Col>
                    <Col span={12}></Col>
                  </Row>
                  <Row>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column-reverse', marginRight: 5, fontWeight: 'bold', }}>
                        <div style={{ height: 35 }}>Close</div>
                        <div style={{ height: 35 }}>Open</div>
                      </div>
                      {schedule.operationtime.map(
                        (operationtime: any, j: number) => {
                          return (
                            <div style={{ flex: 1, 'userSelect': 'none' }} key={j}>
                              <div style={{ fontSize: 14, fontWeight: 500, }}>

                                {operationtime.dayoftheweek}
                              </div>
                              <div style={{ display: 'none', fontSize: 14, fontWeight: 500, }}>
                                <FormItem name={[schedule.id, 'operationtime', j, 'dayoftheweek']}
                                >
                                  <Input style={{ border: '0', color: '#333', backgroundColor: '#fff', }} disabled />
                                </FormItem>
                              </div>
                              <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', padding: '20 0' }}>
                                <div style={{ height: 40, lineHeight: '40px', width: '80%', margin: 'auto', cursor: 'pointer' }}>
                                  <FormItem name={[schedule.id, 'operationtime', j, 'starttime']} >
                                    <TimePicker onChange={onChangeItem} format={itemFormat} />
                                  </FormItem>

                                </div>
                              </div>
                              <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', borderTop: '0', padding: '20 0' }}>
                                <div style={{ height: 40, lineHeight: '40px', width: '80%', margin: 'auto', cursor: 'pointer' }}>
                                  <FormItem name={[schedule.id, 'operationtime', j, 'endtime']}>
                                    <TimePicker onChange={onChangeItem} format={itemFormat} />
                                  </FormItem>
                                </div>
                              </div>
                            </div>
                          )
                        }
                      )}
                    </div>
                  </Row>
                  <Row gutter={24} style={{ marginTop: '12px' }}>
                    <Col span={24}>
                      <Form.Item
                        label="Description"
                        name={[schedule.id, 'description']}
                        rules={[
                          { max: 300, message: 'You have reached the max character length of 300' }
                        ]}
                      >
                        <TextArea maxLength={300} rows={3} onChange={onChangeItem} />
                      </Form.Item>
                    </Col>

                  </Row>
                  <Collapse defaultActiveKey={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']} ghost key={refreshCount} style={{ marginTop: '30px' }}>
                    <>
                      {schedule.charge.map((charge: any, v: any) => {
                        return (
                          <React.Fragment key={v}>
                            {charge.type != "  " && charge.type != null ?
                              <Panel
                                collapsible="header"
                                header={`Charge ${v + 1}`}
                                key={v}
                                className="panel-border"
                                extra={
                                  <Popconfirm
                                    placement="leftTop"
                                    title={`Are you sure you want to delete Charge ${v + 1}?`}
                                    onConfirm={(e) => deleteItem(v, e)}
                                    okText="Yes"
                                    cancelText="No">
                                    <CloseCircleOutlined className="panel-btn" />
                                  </Popconfirm>

                                }
                              >
                                <Row gutter={24}>
                                  <Col span={6} >
                                    <FormItem name={[schedule.id, 'charge', v, 'type']} label="Charge Type">
                                      <Select allowClear onChange={()=>setRequiredFlag(true)}
                                      showSearch>
                                        <Option value="Amount">Amount</Option>
                                        <Option value="Percent">Percent</Option>
                                      </Select>
                                    </FormItem>
                                  </Col>
                                  <Col span={6} className="col-margin">
                                    <Form.Item shouldUpdate noStyle>
                                      {({ getFieldValue }) => {
                                        switch (getFieldValue([schedule.id, 'charge', v, 'type'])) {
                                          case 'Amount':
                                            return <><FormItem style={{ marginBottom: '2px' }} name={[index, 'charge', v, 'charge']} label={'Charge (Amount)'} rules={[
                                              { required: requiredFlag, message: 'This field is required' },
                                              { pattern: /^\d*(\.\d*)?$/, message: 'This field should be a number.' }
                                            ]}>
                                              <Input />
                                            </FormItem><span className="blue-font">Please input the amount value for each charge. Input 0 if free of charge, or leave the field blank if not applicable.</span></>
                                          case 'Percent':
                                            return <FormItem name={[schedule.id, 'charge', v, 'charge']} label={'Charge (Percent)'} rules={[
                                              { required: requiredFlag, message: 'This field is required' },
                                              { pattern: /^\d*(\.\d*)?$/, message: "This field should be a number." }
                                            ]}>
                                              <Input />
                                            </FormItem>
                                          default:
                                            return null
                                        }
                                      }}
                                    </Form.Item>
                                  </Col>
                                  <Col span={6} >
                                    <Form.Item shouldUpdate noStyle>
                                      {({ getFieldValue }) => {
                                        switch (getFieldValue([schedule.id, 'charge', v, 'type'])) {
                                          case 'Amount':
                                            return <FormItem name={[schedule.id, 'charge', v, 'currency']} label="Currency" rules={[{ required: requiredFlag, message: "This field is required" }]}>
                                              <Select allowClear showSearch>
                                                {currencyList.length > 0 && currencyList.map((item: any, index: any) => {
                                                  return (
                                                    <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                                  )
                                                })}
                                              </Select>
                                            </FormItem>
                                          default:
                                            return null
                                        }
                                      }}
                                    </Form.Item>
                                  </Col>
                                  <Col></Col>
                                </Row>
                                <Row gutter={24}>
                                  <Col span={8} >
                                    <FormItem name={[schedule.id, 'charge', v, 'chargeunit']} label="Charge Unit">
                                      <Select allowClear onChange={onChangeItem}
                                      showSearch>
                                        {chargeUnitList.length > 0 && chargeUnitList.map((item: any, index: any) => {
                                          return (
                                            <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                          )
                                        })}</Select>
                                    </FormItem>
                                  </Col>
                                  <Col span={16}>
                                    <FormItem name={[schedule.id, 'charge', v, 'chargefrequency']} label="Charge Frequency">
                                      <Select allowClear onChange={onChangeItem}
                                      showSearch>
                                        {ChargeFrequency.length > 0 && ChargeFrequency.map((item: any, index: any) => {
                                          return (
                                            <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                          )
                                        })}</Select>
                                    </FormItem>
                                  </Col>
                                </Row>
                              </Panel> : null}</React.Fragment>

                        )
                      })}
                    </>
                  </Collapse>
                </Card>

                <span
                  style={{ cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                  onClick={() => {
                    addCertification()
                  }}
                >
                  <PlusOutlined style={{ marginRight: 4 }} />Add Charge
                              </span>


              </TabPane>
            ))}
          </Tabs>
        </Form>
      </div>
      {/* <Card>
        <div style={{ height: '50px', display: 'flex', justifyContent: 'flex-end', padding: '8px', marginTop: '10px' }}>
          <p>
            <Button type='primary' style={{ background: '#fff', width: 90, borderRadius: 3, color: '#004771', borderColor: '#ccc' }} onClick={() => { props.cancelAndSave() }}>Cancel</Button>
            <Button onClick={saveClick} type='primary' style={{ background: '#004771', width: 90, borderRadius: 3, color: '#fff', borderColor: '#004771', marginLeft: 10 }}>Save</Button>
          </p>
        </div>
      </Card> */}
    </>
  )
})

export default AddAccessibilityAndSecurity
